import { useContext } from "react"

// Context
import { UserContext } from "../../../context/userContext"

export default function AssessmentListTableSharedBy({
  rowData,
  organizations,
}) {
  const userCtx = useContext(UserContext)

  const organization = organizations?.filter(
    (organization) => organization.organization_id === rowData.organizationId
  )

  if (organization?.length > 0) {
    return <>{organization[0].organization_name}</>
  } else if (rowData.organizationId === userCtx.session.user.enterprise_id) {
    return <>{userCtx.session.user.enterprise_name}</>
  } else {
    return <>Unknown organization</>
  }
}
